module.exports = __webpack_public_path__ + "static/img/toolbox-stack.0f2a9698.svg";